module.exports = __webpack_public_path__ + "img/logo-dark.65c6a8f4.png";